














































































































































































import { Component, Vue } from 'vue-property-decorator'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import GroupImageSelector from '@/components/Groups/GroupImageSelector.vue'
import { getBoUrl } from '@/api/http-constants'
import { IGroup } from '@/types/group'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperationID } from '@/api/operations'
import { Image } from '@/types/image'
import PixabayModule from '@/store/modules/pixabay'

interface Errors {
    image: boolean
    name: boolean
    sharedSpace: boolean
    wishedCopros: boolean
    surface: boolean
    description: boolean
}

@Component({
    components: {
        GroupImageSelector,
        SmoothReflow,
    },
})
export default class NewGroupForm extends Vue {
    selectedImage: Image | null = null
    userID: number | null = null
    opeID: number | null = null
    boUrl: string = getBoUrl()
    showGroupForm = true
    smoothReflowSettings = {
        transitionEvent: {
            selector: '.transitionTarget',
        },
    }
    settings = {
        copyClassesToDropdown: false,
    }
    newGroup: IGroup | null = null
    errors: Errors | null = null
    sharedSpaces = []
    placeholderCreationGroupe = `Comment voyez-vous cet espace ? (aménagement, équipement, usages, valeurs...) Exemple : Espace pour mélomanes amateurs et avertis : une cabine de prise de son et un studio d'enregistrement à l'acoustique dédiée avec système audio intégré et tables de mixage. Un lieu d'échange et de collaboration musicale.`

    async created() {
        const apiService = new ApiService()
        this.reset()

        await UserModule.Init()
        this.userID = UserModule.userInfos.id
        this.opeID = await getOperationID()

        const sharedSpacesResp = await apiService.getSharedSpaces()
        const sharedSpaces = sharedSpacesResp.data
        this.sharedSpaces = sharedSpaces
    }

    async handleSubmit() {
        if (!this.isValid()) {
            return
        }

        const apiService = new ApiService()

        const surface = parseInt(this.newGroup.surface.toString(), 10)
        const newGroup: IGroup = {
            ...this.newGroup,
            operation: this.opeID,
            owner: this.userID,
            surface: surface,
            pixabay: this.selectedImage.webformatURL,
        }
        delete newGroup.motiviation

        await apiService.postGroup(newGroup)

        this.$emit('alert', {
            type: 'success',
            message:
                'Merci, notre équipe se charge de traiter votre demande de création de groupe dans les plus brefs délais',
            duration: 5000,
        })

        this.$emit('done')
    }

    isValid() {
        this.resetErrors()
        console.log(this.newGroup.wishedCopros)
        if (!this.selectedImage) {
            this.errors.image = true
            return false
        }
        if (!this.newGroup.name) {
            this.errors.name = true
            return false
        }
        if (!this.newGroup.sharedSpace) {
            this.errors.sharedSpace = true
            return false
        }
        if (!this.newGroup.wishedCopros || this.newGroup.wishedCopros <= 0) {
            this.errors.wishedCopros = true
            return false
        }
        if (!this.newGroup.surface) {
            this.errors.surface = true
            return false
        }
        if (!this.newGroup.description) {
            this.errors.description = true
            return false
        }

        return true
    }

    reset() {
        this.resetErrors()

        this.newGroup = {
            operation: null,
            sharedSpace: null,
            owner: null,
            name: null,
            pixabay: null,
            motiviation: null,
            description: null,
            wishedCopros: null,
            surface: null,
            isExterior: 0,
        }

        this.selectedImage = null
        PixabayModule.cleanup()
    }

    resetErrors() {
        this.errors = {
            image: false,
            name: false,
            sharedSpace: false,
            wishedCopros: false,
            surface: false,
            description: false,
        }
    }

    onSelectedImage(image: Image) {
        this.showGroupForm = true
        this.selectedImage = image
    }
}
